import { render, staticRenderFns } from "./details-du-demenagement.vue?vue&type=template&id=25e0c851"
import script from "./details-du-demenagement.vue?vue&type=script&lang=js"
export * from "./details-du-demenagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports